import { render, staticRenderFns } from "./TablaPlanesPagosConceptosUniversidades.vue?vue&type=template&id=5253f620&scoped=true"
import script from "./TablaPlanesPagosConceptosUniversidades.vue?vue&type=script&lang=js"
export * from "./TablaPlanesPagosConceptosUniversidades.vue?vue&type=script&lang=js"
import style0 from "./TablaPlanesPagosConceptosUniversidades.vue?vue&type=style&index=0&id=5253f620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5253f620",
  null
  
)

export default component.exports